<section class="route-surface not-found-page">
  <p class="section-eyebrow">Access</p>
  <h2 class="page-title">Route Not Found</h2>
  <p class="page-copy">
    The canonical `#/404` route and the legacy `#/access/404` alias are both wired. Feature
    routing exists; parity guards and redirect policy land in later steps.
  </p>

  <a class="not-found-page__link" [routerLink]="signInPath">
    Go to sign-in
  </a>
</section>
